export function hashObject(value: string | object): number {
  let data: string;
  if (typeof value === 'object') {
    try {
      data = JSON.stringify(value);
    } catch (e) {
      throw new Error('Object cannot be hashed');
    }
  } else if (typeof value === 'string') {
    data = value;
  } else {
    throw new Error('Value cannot be hashed');
  }
  // tslint:disable-next-line: no-bitwise
  return data.split('').reduce((prevHash, currVal) => ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0, 0);
}
